import { render, staticRenderFns } from "./Money.vue?vue&type=template&id=fd2ab1d4&scoped=true&"
import script from "./Money.vue?vue&type=script&lang=js&"
export * from "./Money.vue?vue&type=script&lang=js&"
import style0 from "./Money.vue?vue&type=style&index=0&id=fd2ab1d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2ab1d4",
  null
  
)

export default component.exports